import React from "react";
import { Loader2 } from "lucide-react";

export default function Loader({ label = "Loading…" }) {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-background grain"
      data-testid="full-screen-loader"
    >
      <Loader2 className="h-7 w-7 animate-spin text-sky-400" />
      <p className="mt-4 text-sm text-muted-foreground tracking-wide">{label}</p>
    </div>
  );
}
